import {
  dehydrateApolloClient,
  getMaintainedParam,
  initApolloClient,
} from "../apolloClient";
import {
  FIND_LISTINGS,
  FIND_LISTINGS_WITH_SOV,
} from "@/graphql/queries/find.listings";
import { SERVICE_RATES_QUERY } from "@/graphql/queries/rating";

const isPage = new RegExp(/^[0-9]+$/);

export const District = {
  Resolve: async (ctx, $res) => {
    /**
     * Here I can query for listing by category,city,direction and page if
     * it exists.
     * ctx: NextPageContext {req,query,...etc.}
     *
     * */
    const { getQuickFiltersCategoryFields } = await import(
      "../../pages/api/[category]/fields"
    );
    const { districts } = await import("./ssr/districts");
    const { description } = await import("./ssr/categories");
    ctx.path = ctx.path || {};
    const [, , directionOrDistrict, districtOrPage, pageOrListing, tooLong] =
      ctx?.query?.params || [];

    if (
      ctx.path.direction &&
      !districts[
        `${ctx.path.city.uri}/${ctx.path.direction.uri}/${districtOrPage}`
      ]
    ) {
      if (!pageOrListing) throw ` حي غير موجود`;
      else return;
    }

    ctx.path.isStatResults = false;

    /*
     * we will read district from our dictionary
     * and store it in ctx.path.district depending on whether we have a direction or not
     * */
    if (ctx.path.direction) {
      ctx.path.district =
        districts[
          `${ctx.path.city.uri}/${ctx.path.direction.uri}/${districtOrPage}`
        ];
    } else {
      ctx.path.district =
        districts[`${ctx.path.city.uri}/${directionOrDistrict}`];
    }

    if (!ctx.path.district)
      if (!districtOrPage) throw `جهة غير موجودة`;
      else return;

    if (!ctx.path.direction && districtOrPage && !isPage.test(districtOrPage)) {
      return {}; // resume to next;
    }
    if (pageOrListing && !isPage.test(pageOrListing)) {
      return {}; // resume to next;
    }

    ctx.path.page = parseInt(pageOrListing, 10);
    if (isPage.test(districtOrPage))
      ctx.path.page = parseInt(districtOrPage, 10);
    ctx.path.district.title = `${ctx.path.category?.plural} في ${ctx.path.city.name} ${ctx.path.district.name}`;
    if (tooLong) return {};
    ctx.path.district.path = `/${ctx.path.category.uri}/${ctx.path.city.uri}/${ctx.path.district.uri}`;
    if (ctx.path.direction) {
      ctx.path.district.path = `/${ctx.path.category.uri}/${ctx.path.city.uri}/${ctx.path.direction.uri}/${ctx.path.district.uri}`;
    }

    if (ctx.path.page === 1) {
      return ctx.redirect(ctx.req.url.replace(`/${ctx.path.page}`, ""));
    }
    const descriptionTemplate = description[ctx.path.category.uri];
    ctx.path.district.description = descriptionTemplate
      ? descriptionTemplate.replace(
          /%place/g,
          ctx.path.district.name + " " + ctx.path.city.name,
        )
      : `${ctx.path.category.name} في ${ctx.path.district.name}`;

    ctx.path.district.description = ctx.path.filtersAsText
      ? ctx.path.district.description + " " + ctx.path.filtersAsText
      : ctx.path.district.description;
    if (ctx.sov) {
      ctx.sov.district_id = ctx.path.district?.id;
    }

    const client = initApolloClient();
    const pathFilters = ctx.path.filters || {};
    const { villa_type, ...filters } = pathFilters;
    const maintainedParam = getMaintainedParam(
      ctx.authState?.user?.cooperative,
    );
    const where = {
      city_id: {
        eq: ctx.path.city?.id,
      },
      district_id: {
        eq: ctx.path.district?.id,
      },
      ...filters,
      ...(filters?.price_12_payments?.gte > 1
        ? {
            price_12_payments: { gte: filters.price_12_payments.gte * 12 },
          }
        : {}),
      ...(villa_type?.eq && { villa_type: villa_type.eq }),
      unpublished: undefined,
      ...maintainedParam,
    };
    if (ctx.path.category.id) {
      where.category = {
        eq: ctx.path.category.id,
      };
    }
    if (ctx.path.direction?.id) {
      where.direction_id = {
        eq: ctx.path.direction?.id,
      };
    }

    const { data } = await client.query({
      query: ctx.sov ? FIND_LISTINGS_WITH_SOV : FIND_LISTINGS,
      context: { aqarPlus: ctx.authState?.token },
      variables: {
        size: 20,
        from: ((ctx.path.page || 1) - 1) * 20,
        sort: {
          create_time: "desc",
          has_img: "desc",
        },
        where,
        sov: ctx.sov,

        daily_renting_filter: ctx.path.daily_renting_filter,
      },
    });
    if (data?.Web?.find?.listings?.length <= 10 && !ctx.path.page) {
      await client.query({
        query: ctx.sov ? FIND_LISTINGS_WITH_SOV : FIND_LISTINGS,
        context: { aqarPlus: ctx.authState?.token },
        variables: {
          size: 20 - (data?.Web?.find?.listings?.length || 0),
          from: 0,
          sort: {
            create_time: "desc",
            has_img: "desc",
          },
          where: {
            ...where,
            district_id: undefined,
          },
          sov: ctx.sov,
          daily_renting_filter: ctx.path.daily_renting_filter,
        },
      });
    }

    await client.query({
      query: SERVICE_RATES_QUERY,
      variables: {
        district_id: ctx.path.district?.id,
      },
    });
    return $res(dehydrateApolloClient(client, {}));
  },
};
export default District;
